import React from 'react'

import styled from 'styled-components';

const ProfileContainer = styled.div`
  flex: 6;
  margin-top: 70px;
`;

const Taskmanagement = () => {
  return (
     <ProfileContainer>
    <div>Taskmanagement</div>
      </ProfileContainer>
  )
}

export default Taskmanagement